import Resource from './Resource';
import AppService from 'App/legacy/AppService';
import type { Metadata } from 'App/resources/AllIWant';

/*
	Standalone Metadata (WEB-7780). Ports the single member React needs — get() — off the Angular
	factory in upsales/common/resources/metadata.js.

	Two details are load-bearing:

	- The endpoint answers `{ error: null, data: metadata }`. The Angular factory unwrapped that once
	  ($resource populates the instance with the response body, then `_.property('data')`), so the
	  caller received the bare metadata object. `_getRequest` resolves with the axios response, which
	  is one level further out, hence `res.data.data`.
	- `_url` deliberately has no trailing slash. `_getUrl` appends the (empty) path with a `/`, so
	  `${customerId}/metadata` produces `.../{customerId}/metadata/` — exactly the URL the Angular
	  $resource built. A trailing slash here would yield `metadata//`, which the API route regex
	  (`/metadata/?$`) does not match.
*/
class MetadataResource extends Resource {
	constructor() {
		super('metadata');
	}

	get(): Promise<Metadata> {
		const customerId = AppService.getCustomerId();
		return this._getRequest('', { _url: `${customerId}/metadata`, methodName: 'get' }).then(
			(res: { data: { data: Metadata } }) => res.data.data,
			// The Angular factory rejected with the bare status code rather than an Error. Kept as-is
			// so any future caller sees the same rejection value it would have seen before.
			(err: { response?: { status: number } }) => {
				// eslint-disable-next-line no-throw-literal
				throw err.response?.status;
			}
		);
	}
}

export default new MetadataResource();
